
import style from '../CSS/RoundVideoResult.module.css'

const Round = ({round, status}) => {
    return (
        <>
            <div className={style.round__wrap}>
                <p className={style.audition__round__text}>Round</p>
                <div className={style.audition__round__number}>{round}</div>
                <button className={ status === 'running' ? style.audition__round__button_active : style.audition__round__button__inactive}>{status}</button>
            </div>
        </>
    );
};

export default Round;